import { useTranslation } from "react-i18next";
import { InputText } from "../../../../_metronic/elements/Inputs";


const ChangePasswordForm = ({ formik }) => {
  const { t } = useTranslation();
  const fields = [
    {
      name: "old_password",
      label: t("account:change_password.inputs.old_password.placeholder")
    },
    {
      name: "new_password",
      label: t("account:change_password.inputs.new_password.placeholder")
    },
    {
      name: "repeat_new_password",
      label: t("account:change_password.inputs.repeat_new_password.placeholder")
    }
  ];

  return (
    <div className="specific-account-edit-list specific-account-password-list">
      {fields.map((field) => (
        <div className="specific-account-edit-row" key={field.name}>
          <label className="specific-account-edit-row__label" htmlFor={field.name}>
            {field.label}
          </label>
          <div className="specific-account-edit-row__control">
            <InputText
              formik={formik}
              name={field.name}
              inputProps={{
                disabled: formik.isSubmitting,
                id: field.name,
                placeholder: field.label,
                type: 'password'
              }}
            />
          </div>
        </div>
      ))}
    </div>
  )
};

export default ChangePasswordForm;
